module.exports = __webpack_public_path__ + "img/n.0877abac.jpg";